<template>
  <div>
    <div v-if="!loading">
      <table-cadu
        v-model="selected"
        class="mandatos"
        :custom="true"
        :rows="rows"
        :rowsHeader="rowsHeader"
        :items="['05', '10', '15']"
        :elementsPerPageProp="tamanhoPagina"
        :editar="acao === 'add' || acao === 'edit'"
        :pagina="pagina"
        :qtPaginas="qtPaginas"
        :qtResultados="qtResultados"
        :showFiltro="false"
        :disabledButtons="visualizar"
        :texto="acao === 'view' ? '' : '+ adicionar dirigente'"
        nameTab="modalDirigentes"
        @change-element="(element) => changeElement(element)"
        @change-page="(obj) => changePage(obj.currentPage)"
        @clickButton="(obj) => clickButton(obj)"
        @ordena="(ordem) => ordernaTable(ordem)"
      />
    </div>
    <ExcluirModal
      :showDelete="showDelete"
      :text="tipoDirigenteMessage"
      @close="fecharDelete"
      @confirmDelete="confirm()"
    />
    <SucessoModal :showSucess="showSucess" :sucessType="type" successName="Dirigente" @close="fecharSucesso" />
    <error-modal v-model="error" :errObj="errObj" />
    <component-loading style="height: 160px;" :value="loading" />
  </div>
</template>

<script>
import Dirigentes from '@/services/Mandatos/Dirigentes'
import { EventBus } from '@/services/EventBus/EventBus'

export default {
  props: {
    idMandato: {
      type: [Number, String],
      required: false
    },
    texto: {
      type: String
    },
    acao: {
      type: String,
      default: 'view'
    },
    tipoDirigente: {
      type: String,
      default: 'dirigente'
    },
    visualizar: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [true, false, false]
    }
  },
  data() {
    return {
      selected: [],
      hoverIndex: -1,
      showButton: false,
      editar: JSON.parse(localStorage.getItem('optionEdit')),
      rows: [],
      rowsHeader: [
        { text: 'Tratamento', icon: 'repeat' },
        { text: 'Nome', icon: 'repeat' },
        { text: 'Cargo', icon: 'repeat' }
      ],
      pagina: 1,
      qtPaginas: 0,
      qtResultados: 0,
      tokenBearer: '',
      tamanhoPagina: 5,
      tipoOrdem: 'id',
      ordem: 'asc',
      loading: false,
      delSelected: [],
      showDelete: false,
      showSucess: false,
      type: '',
      idMandatoData: this.idMandato,
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      }
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    this.loading = true
    await this.getDirigentes()
    this.loading = false
  },
  methods: {
    async fecharSucesso() {
      this.showSucess = false
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden'
    },
    async fecharDelete() {
      this.showDelete = false
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden'
    },
    clickButton(obj) {
      let type = obj.type
      switch (type) {
        case 'add':
          this.$emit('click', { type: 'add' })
          break
        case 'view':
          this.$emit('click', { type: 'view', dirigente: this.rows[obj.index] })
          break
        case 'edit':
          this.$emit('click', { type: 'edit', dirigente: this.rows[obj.index] })
          break
        case 'delete':
          this.type = 'del'
          this.delSelected.push(this.rows[obj.index].id)
          this.showDelete = true
          break
        case 'delAll':
          this.type = 'del'
          this.delSelected = obj.selected
          this.showDelete = true
          break
        default:
          break
      }
    },
    async ordernaTable({ index }) {
      this.ordem = this.ordem === 'asc' ? 'desc' : 'asc'

      switch (index) {
        case 0:
          this.tipoOrdem = 'id'
          break
        case 1:
          this.tipoOrdem = 'dirigente.nome'
          break
        case 2:
          this.tipoOrdem = 'cargo.nome'
          break
      }

      this.loading = true
      await this.getDirigentes()
      this.loading = false
    },

    async getDirigentes() {
      let dirigentes = new Dirigentes(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        let responseGet =
          this.acao === 'view'
            ? await dirigentes.getDirigentesEdit(this.args, this.idMandato)
            : await dirigentes.getDirigentesAdd(this.args)
        responseGet = responseGet.data
        this.rows = responseGet.conteudo
        this.pagina = responseGet.pagina
        this.qtPaginas = responseGet.qtPaginas
        this.qtResultados = responseGet.qtResultados
        this.$emit('rowSize', this.rows.length)
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
    },
    async confirm() {
      this.showDelete = false
      this.loading = true
      await this.$nextTick()
      document.documentElement.style.overflow = 'hidden'
      await this.delDirigentes()
      EventBus.$emit('atualizarTabela')
      localStorage.setItem('dirigentesMudaram', true)
    },
    async changePage(page) {
      this.pagina = page
      this.loading = true
      await this.getDirigentes()
      this.loading = false
    },
    async changeElement(element) {
      this.tamanhoPagina = element
      this.pagina = 1
      this.loading = true
      await this.getDirigentes()
      this.loading = false
    },
    async delDirigentes() {
      let dirigentes = new Dirigentes(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      try {
        await dirigentes.delDirigentes(this.delSelected, this.idMandato)
        await this.getDirigentes()
        this.loading = false
        this.showSucess = true
        this.delSelected = []
      } catch (err) {
        this.error = true
        this.loading = false
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
    },
    downRow() {
      this.showButton = false
      this.hoverIndex = -100
    },
    hoverRow(index) {
      this.showButton = true
      this.hoverIndex = index
    }
  },
  computed: {
    args() {
      return `ordenacao=${this.tipoOrdem}&direcaoOrdenacao=${this.ordem}&tamanhoPagina=${this.tamanhoPagina}&pagina=${this.pagina}&mandatoId=${this.idMandatoData}`
    },
    tipoDirigenteMessage() {
      return `Tem certeza que deseja excluir esse ${this.tipoDirigente}?`
    }
  }
}
</script>

<style lang="sass">
.mandatos
    width: 100%

.circle-status
  border-radius: 10px
  width: 9px
  height: 9px

.mandatos > .table-cadu
  border: none
  border-radius: 0px
  width: 100%
  padding: 0px

.mandatos > .table-cadu > .table > table
  width: 100%
  tbody
      tr
          td
              &:last-child
                  width: 360px
</style>
